import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { Category } from "../../categories.types";
import { requestUpdateSubCategory } from "./updateSubCategory.request";

const useUpdateSubCategory = (
  options?: MutationOptions<Category, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestUpdateSubCategory,
    ...options
  });
};

export default useUpdateSubCategory;
